import type { QueryClient } from "@tanstack/react-query";
import { UsersApi } from "@/openapi/generated";
import type { ScrollUserRequest, SearchQueryRequest } from "@/openapi/generated";
import { QueryKeys } from "@/lib/types";
import { createAuthenticatedApi } from "@/lib/utils";

export async function prefetchUsersScrollGet(
  queryClient: QueryClient,
  page: number | undefined = 1,
  pageSize: number = 100,
  lastSelectedId: number | null = null,
  active?: boolean,
  accessToken?: string,
  roleNames: string[] = [],
  studentSeasonIds: number[] = [],
  studentLocationIds: number[] = [],
  searchQueryRequest: SearchQueryRequest | null = null,
  scrollUserRequest?: ScrollUserRequest,
) {
  if (!accessToken) {
    throw new Error("Access token is required for prefetching users");
  }

  const service = createAuthenticatedApi(UsersApi, accessToken);
  const resolvedScrollRequest: ScrollUserRequest =
    scrollUserRequest ?? {
      studentLocationIds,
      studentSeasonIds,
      locationIds: [],
      roleNames,
      active: active ?? null,
      searchQuery: searchQueryRequest ?? null,
    };

  await queryClient.prefetchQuery({
    queryKey: [
      QueryKeys.UsersScrollGet,
      page,
      pageSize,
      active,
      lastSelectedId,
      resolvedScrollRequest,
      true,
    ],
    queryFn: () =>
      service.usersScrollPost({
        scrollUserRequest: resolvedScrollRequest,
        page,
        pageSize,
        lastSelectedId: lastSelectedId ?? undefined,
        active,
      }),
  });

  return queryClient;
}
